import React, { useState } from "react";
import { Categories } from "./models";
import { useAppDispatch } from "src/store";

interface Props {
  onClose: () => void;
  is_edit?: boolean;
  data?: any;
  id?: number;
  addFunction?: (data: any) => any;
  editFunction?: (data: any) => any;
  titleCG: string;
  categories?: Categories | null;
}

function AddEditModal({
  onClose,
  data,
  id,
  is_edit,
  addFunction,
  editFunction,
  titleCG,
  categories,
}: Props) {
  const [isChecked, setIsChecked] = useState(
    data && data.parent_id ? true : false
  );
  const [parentCategory, setParentCategory] = useState(
    data && data.parent_id ? data.parent_id : ""
  );
  const [nazivCNR, setNazivCNRRef] = useState(
    data && is_edit && data.name ? data.name : ""
  );

  const [requiredCG, setRequiredCG] = useState(false);

  const dispatch = useAppDispatch();
  async function handleSuccess(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (nazivCNR === "") {
      setRequiredCG(true);
      return;
    }
    let data: any = {
      name: nazivCNR,
    };

    if (isChecked && parentCategory !== "") {
      data = { ...data, parent_id: parseInt(parentCategory) };
    }else{
      data = { ...data, parent_id: null };

    }

    if (is_edit) {
      if (editFunction) {
        dispatch(editFunction({ ...data, id }));
      }
    } else {
      if (addFunction) {
        dispatch(addFunction(data));
      }
    }

    onClose();
  }

  return (
    <>
      <div>
        <div className="card-body">
          <div className="tab-content">
            <div>
              <div className="mb-3">
                <label className="form-label">
                  Naziv <span className="form-required-filed">*</span>{" "}
                </label>
                <input
                  type="text"
                  name=" objects[0][naslov] "
                  className="form-control"
                  placeholder={titleCG}
                  value={nazivCNR}
                  onChange={(val) => setNazivCNRRef(val.target.value)}
                  onKeyDown={(e: any) => {
                    if (e.key === "Enter") {
                      handleSuccess(e);
                    }
                  }}
                />
                {requiredCG && (
                  <div className="form-error-message">
                    Naslov je obavezno polje
                  </div>
                )}
              </div>

              {categories && (
                <div className="form-check">
                  <input
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckChecked"
                  >
                    Da li želite dodati ovu kategoriju nekoj vec postojećoj?
                  </label>
                </div>
              )}

              {isChecked && categories && (
                <select
                  onChange={(e) => setParentCategory(e.target.value)}
                  className="form-select mb-3"
                  aria-label="Default select example"
                >
                  <option value=""></option>
                  {categories.data.filter(x => x.id !== data?.id).map((item: any) => (
                    <option
                    key={item.id}
                      selected={parentCategory === item.id}
                      value={item.id}
                    >
                      {item.name}
                    </option>
                  ))}
                </select>
              )}
            </div>
          </div>
        </div>
        <div className="btn-list flex-nowrap justify-content-end">
          <button className="btn btn-primary-outline" onClick={onClose}>
            Obustavi
          </button>
          <button
            onClick={(e: any) => {
              handleSuccess(e);
            }}
            className="btn btn-primary"
          >
            Sačuvaj
          </button>
        </div>
      </div>
    </>
  );
}

export default AddEditModal;
